var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 5.1,
    y: -2.7,
    rx: 1.2,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 1,
    y: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    x: 1,
    y: 4,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFilled);
export default __webpack_public_path__ + "static/media/folder_filled.293c33d786bf644a26e31dd601d791fa.svg";
export { ForwardRef as ReactComponent };